import { memo } from "react";
import WithDriverIconPopup from "./WithDriverIconPopup";

function DriverAtLunchBreakMarker({color}) {
  const backGroundColor = color || "#05A792";
  return (
    <svg
      width="25"
      height="30"
      viewBox="0 0 25 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "scale(2.0)" }}
    >
      <g filter="url(#filter0_d)">
        <path
          d="M14.3144 14.0979V7.31114C14.3188 7.27418 14.3234 7.2296 14.3261 7.18842C14.3294 7.1351 14.3326 7.05019 14.3231 6.95301C14.3215 6.93583 14.3189 6.91176 14.3144 6.88231V5.7364L13.659 6.02103C13.4259 5.91693 13.1919 5.90502 13.0431 5.91676C12.7735 5.93803 12.5375 6.03711 12.3687 6.14143L12.3685 6.14157C10.9507 7.01811 10.1006 8.54254 10.1004 10.2093V10.2095L10.1003 13.8154C10.1003 14.3035 10.321 14.7387 10.667 15.0289V18.1273C10.667 19.1337 11.4842 19.951 12.4907 19.951C13.4972 19.951 14.3145 19.1338 14.3145 18.1273V14.1247V14.0993L14.3144 14.0979Z"
          fill={backGroundColor}
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M8.28201 6.02476C8.40527 5.98001 8.54401 5.95096 8.69502 5.95096C9.04894 5.95096 9.33921 6.1115 9.51371 6.25144C9.69221 6.39459 9.99842 6.72034 9.99853 7.22594V7.22616V11.2102C9.99853 11.6229 9.87828 12.0369 9.63516 12.3722C9.57049 12.4614 9.49304 12.5495 9.4035 12.6306L9.65187 17.7798C9.65187 17.7799 9.65187 17.78 9.65188 17.7801C9.67491 18.256 9.55763 18.7641 9.27653 19.1786L9.27652 19.1786C8.99274 19.597 8.50796 19.951 7.89145 19.951C7.27496 19.951 6.79016 19.5971 6.50636 19.1785L8.28201 6.02476ZM8.28201 6.02476C8.15767 5.98042 8.01752 5.95096 7.86618 5.95096C7.72391 5.95096 7.59243 5.97677 7.47454 6.01713C7.35658 5.9768 7.225 5.95096 7.0827 5.95096C6.72498 5.95096 6.4335 6.11465 6.25851 6.25801C6.07706 6.40666 5.78442 6.73148 5.78442 7.22619V11.2102C5.78442 11.6229 5.90468 12.0369 6.14778 12.3722C6.21243 12.4614 6.28986 12.5494 6.37937 12.6306L6.13102 17.7796C6.13102 17.7797 6.13102 17.7798 6.13101 17.7798C6.13101 17.7799 6.13101 17.7799 6.13101 17.7799C6.10796 18.2559 6.22523 18.764 6.50631 19.1785L8.28201 6.02476Z"
          fill={backGroundColor}
          stroke="white"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.784424"
          y="0.211838"
          width="18.545"
          height="24.7391"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(memo(DriverAtLunchBreakMarker));
